import HttpClient from 'axios-mapper'
import { ElMessage } from 'element-plus'
import { useStore } from '@/store'
import { ResponseCode } from '../api/response'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { deepClone } from '@/utils/utils'
import i18n from '../i18n/index'
import router from '../router'
import { siteEnum } from "@/consts/SiteEnum"

/* eslint-disable */
const toRawType = value => {
  return Object.prototype.toString.call(value).slice(8, -1)
}

const clearQueryStr = param => {
  return param
    .split('&')
    .filter(item => item.split('=')[1] !== '')
    .join('&')
}

const clearEmptyParam = config => {
  ;['data', 'params'].forEach(item => {
    if (config[item]) {
      const rawType = toRawType(config[item])
      if (['Object'].includes(rawType)) {
        const keys = Object.keys(config[item])
        if (keys.length) {
          keys.forEach(key => {
            if (['', undefined, null].includes(config[item][key])) {
              if (['Object'].includes(rawType)) {
                config[item] = deepClone(config[item])
                delete config[item][key]
              }
            }
          })
        }
      } else if (['String'].includes(rawType)) {
        config[item] = clearQueryStr(config[item])
      }
    }
  })
}
const onRequest = config => {
  clearEmptyParam(config)
  return config
}

const onResponse = response => {
  let res = response.data
  if (typeof response.data === 'string') {
    res = JSON.parse(response.data)
  }
  if (res.code !== ResponseCode.SUCCESS) {
    const store = useStore()
    const siteId = store.state.user.siteId
    if (
      res.code === ResponseCode.ERROR_FORBIDDEN ||
      res.code === ResponseCode.ERROR_FORBIDDEN2
    ) {
      if (res.data) {
        sessionStorage.setItem('myIPAddress', res.data)
      }
      if (res.ip) {
        sessionStorage.setItem('myIPAddress', res.ip)
      }
      if (res.loginName) {
        sessionStorage.setItem('myloginName', res.loginName)
      }
      router.push('/403')
      return
    }
    if (res.code === ResponseCode.ERROR_UNAUTHORIZED) {
      ElMessage({
        message: 'Duplicated login.',
        type: 'error',
      })
      store.dispatch(UserActionTypes.ACTION_LOGOUT)
      if (siteId === siteEnum.XF1 || siteId === Number(siteEnum.XF1)) {
        router.go('/xf/login');
      } else if (siteId === '3' || siteId === 3) { // 注意：siteId '3'
        router.go('/th/login');
      } else if (siteId === siteEnum.IND || siteId === Number(siteEnum.IND)) {
        router.go('/ind/login');
      } else if (siteId === siteEnum.DY2 || siteId === Number(siteEnum.DY2)) {
        router.go('/dy/login');
      } else if (siteId === siteEnum.LH1 || siteId === Number(siteEnum.LH1)) {
        router.go('/lh/login');
      } else if (siteId === siteEnum.VNM || siteId === Number(siteEnum.VNM)) {
        router.go('/vi/login');
      } else if (siteId === siteEnum.KRW || siteId === Number(siteEnum.KRW)) {
        router.go('/kr/login');
      } else if (siteId === siteEnum.PAK || siteId === Number(siteEnum.PAK)) {
        router.go('/pak/login');
      } else if (siteId === siteEnum.PH2 || siteId === Number(siteEnum.PH2)) {
        router.go('/ph2/login');
      } else if (siteId === siteEnum.KAKA || siteId === Number(siteEnum.KAKA)) {
        router.go('/kaka/login');
      } else if (siteId === siteEnum.BR1 || siteId === Number(siteEnum.BR1)) {
        router.go('/br1/login');
      } else if (siteId === siteEnum.BR2 || siteId === Number(siteEnum.BR2)) {
        router.go('/br2/login');
      } else if (siteId === siteEnum.LK6 || siteId === Number(siteEnum.LK6)) {
        router.go('/lk6/login');
      }
      location.reload()
    } else if (
      res.code === ResponseCode.ERROR_TOKEN_EXPIRED ||
      res.code === ResponseCode.ERROR_TOKEN_MISSED ||
      res.code === ResponseCode.ERROR_TOKEN_INVALID ||
      res.code === ResponseCode.ERROR_TOKEN_LOGGED ||
      res.code === ResponseCode.ERROR_TOKEN_FAILED
    ) {
      ElMessage({
        message: 'Please re-login. Code: ' + res.code,
        type: 'error',
      })
      store.dispatch(UserActionTypes.ACTION_LOGOUT)
      if (siteId === siteEnum.XF1 || siteId === Number(siteEnum.XF1)) {
        router.go('/xf/login');
      } else if (siteId === '3' || siteId === 3) {
        router.go('/th/login');
      } else if (siteId === siteEnum.IND || siteId === Number(siteEnum.IND)) {
        router.go('/ind/login');
      } else if (siteId === siteEnum.DY2 || siteId === Number(siteEnum.DY2)) {
        router.go('/dy/login');
      } else if (siteId === siteEnum.LH1 || siteId === Number(siteEnum.LH1)) {
        router.go('/lh/login');
      } else if (siteId === siteEnum.VNM || siteId === Number(siteEnum.VNM)) {
        router.go('/vi/login');
      } else if (siteId === siteEnum.KRW || siteId === Number(siteEnum.KRW)) {
        router.go('/kr/login');
      } else if (siteId === siteEnum.PAK || siteId === Number(siteEnum.PAK)) {
        router.go('/pak/login');
      } else if (siteId === siteEnum.PH2 || siteId === Number(siteEnum.PH2)) {
        router.go('/ph2/login');
      }
      location.reload()
    } else {
      // const router = useRouter()
      if (
        res.code === ResponseCode.ERROR_TOKEN_EXPIRED ||
        res.code === ResponseCode.ERROR_TOKEN_INVALID
      ) {
        store.dispatch(UserActionTypes.ACTION_LOGOUT)
        if (siteId === siteEnum.XF1 || siteId === Number(siteEnum.XF1)) {
          router.go('/xf/login');
        } else if (siteId === '3' || siteId === 3) {
          router.go('/th/login');
        } else if (siteId === siteEnum.IND || siteId === Number(siteEnum.IND)) {
          router.go('/ind/login');
        } else if (siteId === siteEnum.DY2 || siteId === Number(siteEnum.DY2)) {
          router.go('/dy/login');
        } else if (siteId === siteEnum.LH1 || siteId === Number(siteEnum.LH1)) {
          router.go('/lh/login');
        } else if (siteId === siteEnum.VNM || siteId === Number(siteEnum.VNM)) {
          router.go('/vi/login');
        } else if (siteId === siteEnum.KRW || siteId === Number(siteEnum.KRW)) {
          router.go('/kr/login');
        } else if (siteId === siteEnum.PAK || siteId === Number(siteEnum.PAK)) {
          router.go('/pak/login');
        } else if (siteId === siteEnum.PH2 || siteId === Number(siteEnum.PH2)) {
          router.go('/ph2/login');
        }
        location.reload()
      }
      if (res.code === 11000) {
        ElMessage({
          message: res.message || 'Error',
          type: 'error',
        })
      } else {
        ElMessage({
          message:
            i18n.global.t('error.' + res.code) +
              (res.data && res.data.parameter ? res.data.parameter : '') ||
            'Error',
          type: 'error',
        })
      }
    }
    throw new Error(res.message || 'Error')
  } else {
    return response
  }
}

const onResponseError = error => {
  ElMessage({
    message: error.message,
    type: 'error',
  })
  return Promise.reject(error)
}

const https = api => {
  const store = useStore()
  const token = store.state.user.token
  const currentHost = window.location.host
  // const thaiHost = "affiliate-web.monemental.com"
  // const indHost = "ind-nfaet6t.exerpsison.com"
  // const ind2Host = "iw2-xt5dzo.xlpfl0qqf3p.com"
  // const lhHost = "lh1-affiliate.phoicynxeey.com"
  const lh3Host = 'lh1-affiliate.55oq61hr66f.com'
  const lh2Host = 'lh1-affiliate.lhf2ifpudro.com'
  const xf1Host = 'affiliate-web.gwd4jptunz.com'
  const xf2Host = 'xf1-affiliate.gwd4jptunz.com'
  const br2Host = 'br2-affiliate.ppk8d1a5rw5.com'
  const br1Host = 'br1-affiliate.ppk8d1a5rw5.com'
  const mx4Host = 'mx4-affiliate.ppk8d1a5rw5.com'
  // const vnmHost = "vnm-affiliate.th80to83w1.com"
  // const krwHost = "krw-affiliate.hiemloelebc.com";
  // const testLocal = "localhost:9998"
  const isAff = api === 'affiliate'
  const isCr = api === 'cashier'
  let apiUrl = process.env.VUE_APP_RST_API

  console.log(currentHost)
  const isLocalhost =
    currentHost.indexOf('localhost') > -1 ||
    currentHost.indexOf('127.0.0.1') > -1
  //Only Global or China.
  if (
    currentHost.indexOf('-cn') > -1 ||
    currentHost.indexOf(lh2Host) > -1 ||
    currentHost.indexOf(lh3Host) > -1 ||
    currentHost.indexOf(xf1Host) > -1 ||
    currentHost.indexOf(xf2Host) > -1
  ) {
    apiUrl = isAff
      ? process.env.VUE_APP_RST_API
      : isCr
      ? process.env.VUE_APP_CR_API
      : process.env.VUE_APP_AFF_API
  } else if (
    currentHost.indexOf('br2-') > -1 ||
    currentHost.indexOf(br2Host) > -1 ||
    currentHost.indexOf('br1-') > -1 ||
    currentHost.indexOf(br1Host) > -1 ||
    currentHost.indexOf('mx4-') > -1 ||
    currentHost.indexOf(mx4Host) > -1
  ) {
    apiUrl = isAff
      ? process.env.VUE_APP_BR2_RST_API
      : isCr
      ? process.env.VUE_APP_BR2_CR_API
      : process.env.VUE_APP_BR2_AFF_API
  } else {
    apiUrl = isAff
      ? process.env.VUE_APP_GLOBAL_RST_API
      : isCr
      ? process.env.VUE_APP_GLOBAL_CR_API
      : process.env.VUE_APP_GLOBAL_AFF_API
  }

  const config = {
    baseURL: apiUrl,
    headers: {
      TOKEN: token,
      Authorization: store.state.user.siteCode,
    },
    timeout: process.env.TIMEOUT,
  }
  const httpClient = new HttpClient(config)
  httpClient.httpClient.interceptors.request.use(onRequest)
  httpClient.httpClient.interceptors.response.use(onResponse, onResponseError)
  return httpClient
}

export default https
